import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _createForOfIteratorHelper from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import $$ from './storage';
var localStoragePlugin = function localStoragePlugin(store) {
  store.subscribe(function (mutation, state) {
    if (mutation.type.indexOf('user/') !== -1) return;
    var st = state;
    var key = '';
    var storageKey = '';
    var _iterator = _createForOfIteratorHelper(mutation.type.split('/')),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var type = _step.value;
        if (type[0] === '_') {
          key = type.substring(1);
          st = st[key];
          storageKey += key;
        } else {
          st = st[type];
          storageKey += type + '/';
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    $$.set(storageKey, st);
  });
};
export default [localStoragePlugin];